import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './UserMenu.css';

interface UserMenuProps {
  name: string;
  role: string;
  restaurantName?: string;
  initials?: string;
  onChangePassword: () => void;
  onLogout: () => void;
  theme?: 'light' | 'dark';
}

export default function UserMenu({
  name, role, restaurantName, initials,
  onChangePassword, onLogout,
  theme = 'light',
}: UserMenuProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const avatarInitials = initials || name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);

  return (
    <div className={`um-wrap um-wrap--${theme}`} ref={ref}>
      <button className="um-btn" onClick={() => setOpen(o => !o)}>
        <div className="um-avatar">{avatarInitials}</div>
        <div className="um-info">
          <div className="um-name">{name}</div>
          <div className="um-role">{role}</div>
        </div>
        <span className={`um-chevron ${open ? 'um-chevron--open' : ''}`}>▾</span>
      </button>

      {open && (
        <div className="um-dropdown">
          <div className="um-dropdown-header">
            <div className="um-dropdown-name">{name}</div>
            <div className="um-dropdown-meta">
              {role}{restaurantName ? ` · ${restaurantName}` : ''}
            </div>
          </div>
          <div className="um-divider" />
          <button
            className="um-item"
            onClick={() => { setOpen(false); onChangePassword(); }}
          >
             {t('common.changePassword')}
          </button>
          <div className="um-divider" />
          <button
            className="um-item um-item--danger"
            onClick={() => { setOpen(false); onLogout(); }}
          >
            ← {t('common.logout')}
          </button>
        </div>
      )}
    </div>
  );
}
